module.exports = __webpack_public_path__ + "static/media/exportToCancerGenomicsCloudIcon.7b2dd231.svg";